const cacheProps = {
  key: `bfin`,
};

export default cacheProps;
